import React, { Component } from 'react';

const GoogleLogo = (props) => {
	return (
		<div class="google_logo">
			<svg width="30px" height="30px" viewBox="0 0 30 30" transform="translate(-0.500000, -0.500000)">
				<g>
					<path fill="#4285F4" d="M22.4,15.2c0-0.5,0-1-0.1-1.5h-7.1v2.9h4c-0.2,0.9-0.7,1.7-1.5,2.3v1.9
						h2.4C21.5,19.4,22.4,17.5,22.4,15.2L22.4,15.2z"/>
					<path fill="#34A853" d="M15.2,22.5c2,0,3.7-0.7,5-1.8l-2.4-1.9c-0.7,0.5-1.5,0.7-2.5,0.7
						c-2,0-3.6-1.3-4.2-3.1H8.4v1.9C9.7,20.8,12.2,22.5,15.2,22.5L15.2,22.5z"/>
					<path fill="#FBBC05" d="M11,16.4c-0.1-0.4-0.2-0.9-0.2-1.4s0.1-1,0.2-1.4v-1.9H8.4
						c-0.5,1-0.8,2.2-0.8,3.4s0.3,2.4,0.8,3.4L11,16.4L11,16.4z"/>
					<path fill="#EA4335" d="M15.2,10.5c1.1,0,2.1,0.4,2.9,1.1l2.2-2.2c-1.3-1.2-3-2-5-2
						c-2.9,0-5.5,1.7-6.7,4.1l2.5,1.9C11.5,11.8,13.2,10.5,15.2,10.5L15.2,10.5z"/>
				</g>
			</svg>
		</div>
	)
}

export default GoogleLogo;